import { PrintRepository } from '../repositories/print.repository'

const printRepository = new PrintRepository()

export class PrintService {
    async printTranscriptDocuments(transcript_id: number, invoice_number: string): Promise<any> {
        const response = await printRepository.printTranscriptDocuments(transcript_id, invoice_number)
        return response.data
    }

    async printLtlMassOrders(params: { orderIds: number[] }): Promise<Blob> {
        const response = await printRepository.printLtlMassOrders(params)
        return response.data
    }
}
